import classnames from 'classnames';
import React, { ReactNode } from 'react';

interface Props {
  name: string;
  id?: string;
  children?: ReactNode;
  sticky?: boolean;
}

export const SettingsTabContent: React.FunctionComponent<Props> = ({ name, id, children, sticky }) => {
  return (
    <div id={id} className={classnames('settings-tab-content', sticky && 'sticky')}>
      {name && <div className="settings-tab-name haiui-heading-04-med">{name}</div>}
      {children}
    </div>
  );
};
